import React from "react";
import { getMenuVersionConfig } from "../../globalData/constant";
import { getLocalStorage, setLocalStorage } from "../../Functions/Utils";

/**
 * Reusable Version Selector Component
 * Displays version dropdown for menus that support multiple versions
 *
 * @param {string} selectedMenu - Current selected menu name
 * @returns {JSX.Element|null} Version selector or null if menu doesn't support versions
 */
const VersionSelector = ({ selectedMenu }) => {
  const versionConfig = getMenuVersionConfig(selectedMenu);
  const storageKey = `${selectedMenu}_version`;

  // React Hooks must be called before any conditional returns
  const [selectedVersion, setSelectedVersion] = React.useState(
    getLocalStorage(storageKey) || versionConfig?.defaultVersion || "1.0",
  );

  // If menu doesn't have version config, don't render anything
  if (!versionConfig || !versionConfig.hasVersions) {
    return null;
  }

  const handleVersionChange = (version) => {
    setSelectedVersion(version);
    setLocalStorage({ [storageKey]: version });
  };

  return (
    <div className="d-flex justify-content-center mb-3">
      <div style={{ minWidth: "200px" }}>
        <label className="form-label text-center d-block mb-2 font_14">
          Select Version
        </label>
        <select
          className="form-select"
          value={selectedVersion}
          onChange={(e) => handleVersionChange(e.target.value)}
          style={{
            padding: "8px 12px",
            borderRadius: "5px",
            border: "1px solid #1A82E2",
            color: "#004C92",
            cursor: "pointer",
          }}
        >
          {versionConfig.versions.map((version) => (
            <option key={version.value} value={version.value}>
              {version.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default VersionSelector;
